import { render, staticRenderFns } from "./staoinfo.vue?vue&type=template&id=4b641654&scoped=true&"
import script from "./staoinfo.vue?vue&type=script&lang=js&"
export * from "./staoinfo.vue?vue&type=script&lang=js&"
import style0 from "./staoinfo.vue?vue&type=style&index=0&id=4b641654&scoped=true&sass=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b641654",
  null
  
)

export default component.exports